import { useContext, useEffect, useRef, useState } from "react";
import { ActivitiesContext } from "../../context/activities-context";
import DistanceFilter from "./DistanceFilter";
import { filter } from "lodash";

const LocationFilter = (props) => {
	var baseLocation = {
		id:"all",
		text:"Alle locaties"
	}
	const dropdownRef = useRef();
	const [inputValue, setInputValue] = useState("");
    const [showLocations, setShowLocations] = useState(false);
	const [filteredLocations, setFilteredLocations] = useState([]);
	const [allLocations, setAllLocations] = useState([]);

	const {
		locations,
		locationButtonId,
		setLocationButtonId,
		locationButtonText,
		setLocationButtonText,
		setLocationString,
		locationQuery,
		setLocationQuery,
		distanceQuery,
		setDistanceQuery,
		toggleActive,
		setToggleActive,
		distanceButtonId,
		setDistanceButtonId,
		setDistanceString,
		dictionaryWords,
		isLoadingDictionary,
	} = useContext(ActivitiesContext);
	const label = dictionaryWords.allLocations;

	useEffect(() => {
		setLocationQuery(locationQuery);
	}, [locationQuery]);

	useEffect(() => {
		setDistanceQuery(distanceQuery);
	}, [distanceQuery]);

	useEffect(() => {
        const checkIfClickedOutside = e => {
          if (
            showLocations &&
            dropdownRef.current &&
            !dropdownRef.current.contains(e.target)
          ) {
            setShowLocations(false)
          }
          else{
            if(inputValue.length >= 3 && dropdownRef.current.contains(e.target))
                setShowLocations(true)
          }
        }
        document.addEventListener("mousedown", checkIfClickedOutside)
        
        return () => {
          document.removeEventListener("mousedown", checkIfClickedOutside)
        }
      }, [showLocations])

	
	useEffect(() => {
		if(locations.length > 0){
			var newLocations = [...locations];
			newLocations.unshift(baseLocation);
			setAllLocations(newLocations)
			setFilteredLocations(newLocations);
		}
	},[locations])

    const handleInputChange = (e) => {
		if(e.target.value.length > 3){
			setShowLocations(true)
		}
		else{
			setShowLocations(false)
		}

        setInputValue(e.target.value);
		var test = filteredLocations;

		if(test.length > 0 && e.target.value != ""){
			test = test.filter(function (str) { return str.text.toLowerCase().includes(e.target.value.toLowerCase()); });
			setFilteredLocations(test);
		}
		else if(e.target.value === ""){
			setFilteredLocations(allLocations)
			locationFilterHandler(baseLocation);
		}
	}

	const locationSelectionHandler = location => {
		setInputValue(location.text);
		setShowLocations(false);
		locationFilterHandler(location);
	}

	const locationFilterHandler = (location) => {
		if (location.id === "all") {
			setLocationQuery("");
			setDistanceQuery("");
			setLocationString(" ");
			setDistanceString("");
			setLocationButtonText("Alle locaties");
			setDistanceButtonId("");
		} else if (location.id !== "all" && distanceButtonId !== "") {
			setLocationQuery(`AND regions:"${location.id}"`);
			setDistanceQuery(
				`&coordinates=${location.lat},${location.lng}`
			);
			setDistanceString(
				`${distanceButtonId}&coordinates=${location.lat},${location.lng}`
			);
			setLocationString("");
			setLocationButtonText(location.text);
		} else if (location.id !== "all" && distanceButtonId === "") {
			setLocationQuery(`AND regions:"${location.id}"`);
			setDistanceQuery(
				`&coordinates=${location.lat},${location.lng}`
			);
			setLocationString(`AND regions:"${location.id}"`);
			setLocationButtonText(location.text);
		}
		setLocationButtonId(location.id);
		setToggleActive((prevToggleActive) => !prevToggleActive);
	};

	const handleClear = () => {
        setInputValue("")
        setShowLocations(false)
		locationFilterHandler(baseLocation);
		setFilteredLocations(allLocations)
    }

	return (
		<div className="filter-section">
			<h3>{dictionaryWords.where}</h3>
			<div
				ref={dropdownRef}
				className= 'c-input c-input--full-width'>
				<input 
					placeholder= {label}
					id="input" 
					className="c-input__field" 
					onChange={e => handleInputChange(e)}
					value={inputValue}
					autoComplete="off"    
				>        
				</input>
				{label && <label htmlFor="input" className="c-input__label">{label}</label>}
				<div className="c-input__right">
					{inputValue === ''? (
						<i className="fal fa-search"></i>
					) : (
						<i onClick={handleClear} className="fal fa-times-circle"></i>
					)}
				</div>

				{showLocations ? (
					<div className="c-input-suggestion__container">
						<ul className="c-input-suggestion__ul">
							{filteredLocations.length > 0 && filteredLocations.map( location => {
								return(
									<li 
										className="c-input-suggestion__li"
										key={location.id} 
										onClick={() => locationSelectionHandler(location)}
									>
										{location.text}
									</li>
								)
							})}
						</ul>
					</div>
				) : (
					<span></span>
				)}
            </div>
			<DistanceFilter />
		</div>
	);
};

export default LocationFilter;
